import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ITaskV2Log } from '@fi-app/task-v2/fi-task-v2';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { FiTaskActionType } from '@fi-app/task-v2/fi-task-v2-enums';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-task-v2-log-item',
    templateUrl: './task-v2-log-item.component.html',
    styleUrl: './task-v2-log-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-log-item' },
    standalone: false,
})
export class TaskV2LogItemComponent {
    @Input({ required: true }) log: ITaskV2Log;
    protected taskLogActionTypeLabels: Record<FiTaskActionType, string> = {} as Record<FiTaskActionType, string>;
    protected taskLogActionTypeIconClasses: Record<FiTaskActionType, string> = {} as Record<FiTaskActionType, string>;
    protected readonly FiProfileSizes = FiProfileSizes;

    constructor(private appTextService: AppTextService) {}

    ngOnInit(): void {
        this.setTaskLogActionTypeLabels();
        this.setTaskLogActionTypeIconClasses();
    }

    private setTaskLogActionTypeLabels(): void {
        this.taskLogActionTypeLabels = {
            [FiTaskActionType.Create]: this.appTextService.get('task_log.created'),
            //[FiTaskActionType.Update]: this.appTextService.get('tasks_log.updated_the_task'),
            [FiTaskActionType.Start]: this.appTextService.get('task_log.started'),
            [FiTaskActionType.SetCompleted]: this.appTextService.get('tasks_log.completed_the_task'),
            [FiTaskActionType.SetNotStarted]: this.appTextService.get('tasks_log.set_not_started'),
            [FiTaskActionType.Cancel]: this.appTextService.get('tasks_log.cancelled'),
            [FiTaskActionType.AddUser]: this.appTextService.get('tasks_log.added_user', {
                '{0}': this.log?.Data?.AddedUsers?.[0]?.Name || '',
            }),
            [FiTaskActionType.Archive]: this.appTextService.get('tasks_log.archived_the_task'),
            [FiTaskActionType.Restore]: this.appTextService.get('tasks_log.restored_the_task'),
            [FiTaskActionType.Reopened]: this.appTextService.get('tasks_log.reopened_the_task'),
            [FiTaskActionType.ReopenedAndSetInProcess]: this.appTextService.get('tasks_log.reopened_the_task'),
            [FiTaskActionType.UpdatePriority]: this.appTextService.get('tasks_log.priority_updated'),
            [FiTaskActionType.UpdateDeadline]: this.appTextService.get('tasks_log.deadline_updated'),
            [FiTaskActionType.UpdateSharingSelection]: this.appTextService.get(
                'task_log.updated_the_sharing_selection',
            ),
        };
    }

    private setTaskLogActionTypeIconClasses(): void {
        this.taskLogActionTypeIconClasses = {
            [FiTaskActionType.Create]: 'far fa-pen-to-square',
            //[FiTaskActionType.Update]: 'far fa-pen-to-square',
            [FiTaskActionType.Start]: 'far fa-hourglass-half',
            [FiTaskActionType.SetCompleted]: 'far fa-clipboard-check',
            [FiTaskActionType.SetNotStarted]: 'far fa-clipboard',
            [FiTaskActionType.Cancel]: 'far fa-circle-x',
            [FiTaskActionType.AddUser]: 'far fa-user-plus',
            [FiTaskActionType.Archive]: 'far fa-box-archive',
            [FiTaskActionType.Restore]: 'far fa-arrow-rotate-left',
            [FiTaskActionType.Reopened]: 'far fa-clipboard',
            [FiTaskActionType.ReopenedAndSetInProcess]: 'far fa-hourglass-half',
            [FiTaskActionType.UpdatePriority]: 'far fa-circle-exclamation',
            [FiTaskActionType.UpdateDeadline]: 'far fa-calendar-circle-exclamation',
            [FiTaskActionType.UpdateSharingSelection]: 'fa-regular fa-share-nodes',
        };
    }
}
